import { User } from 'compliance-api';
import { useGetTaskQuery } from '@/modules/common/queries/tasks.ts';
import TaskResultInfoModal from '@/modules/admin-dashboard/components/modals/TaskResultInfoModal.tsx';
import { BaseModalProps, ModalContentWrapper, Spinner } from 'ui';

interface TaskResultInfoModalWithLoadingProps extends BaseModalProps {
  user: User;
  taskId: number;
  resultId: number;
}

const TaskResultInfoModalWithLoading = ({
  open,
  user,
  taskId,
  resultId,
  onClose,
}: TaskResultInfoModalWithLoadingProps) => {
  const { data, isLoading } = useGetTaskQuery(taskId);

  const result = (data?.task.task_results || []).find(res => res.id === resultId);

  if (isLoading || !data || !result) {
    return (
      <ModalContentWrapper
        title=""
        variant="right"
        open={open}
        onClose={onClose}
        classes={{ dialogPanel: 'max-w-xl', children: 'flex justify-center items-center' }}
      >
        {isLoading ? <Spinner size="lg" /> : <div>Something went wrong, task result not found</div>}
      </ModalContentWrapper>
    );
  }

  return (
    <TaskResultInfoModal
      open={open}
      onClose={onClose}
      taskResultInfo={{ task: data.task, result: result, user }}
    />
  );
};

export default TaskResultInfoModalWithLoading;
